import BasePage from "@/views/BasePage/BasePage";
import OverlayLoader from "./components/overlayLoader/overlayLoader";

import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";

import Loading from "./components/loading/loading";

@Component({
  components: {
    OverlayLoader,
    Loading,
  },
})
export default class App extends BasePage {
  @Action action_autoLogin: any;
  @Action action_getCity;
  @Action action_getMenus;
  @Action action_getMenuPrices;

  @Mutation IS_TOKEN: any;

  @Getter getUser: any;
  @Getter getIsToken: any;
  @Getter getSpinner: any;
  @Getter getCity;

  @Mutation SPINNER;

  isFetchingMainInfo = false;

  mounted() {
    this.fetchInitialData();
  }

  async fetchInitialData() {
    this.isFetchingMainInfo = true;
    await this.action_getCity();
    await this.action_getMenus({ commerceId: this.getCity.id });
    await this.action_getMenuPrices();
    if (this.getIsToken) {
      await this.action_autoLogin();
    }
    this.isFetchingMainInfo = false;
  }
}
